import React, { useState, useEffect } from 'react';
import './HeroSection.css';
// import { assets } from '../../assets/assets'
// import PromotionalBanner from '../PromotionalBanner/PromotionalBanner';

const images = [
  '/front-end-images/img1.png',
  '/front-end-images/img2.png',
  '/front-end-images/img3.png', // Add more images if needed
];

const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Automatically change the image every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval); // Clear interval on component unmount
  }, []);

  return (
    
    <section
      className="hero-sections"
      style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
    >
     
      <div className="overlay">
       
        <div className="hero-content">
          
          <h1 className='hero-h1'>Improve Your Learning Experience...</h1>
          <p>
            Explore 2k+ courses with 50k+ registered students. Find the right course for you.
          </p>
          <div className="trust-indicator">
            <span>
              50K+ People already trusted us. 
            </span>
          </div>
        </div>
        {/* <div className="hero-images">
          <img src={assets.banner_img} alt="Learning Illustration" />
        </div> */} 
      </div>
    </section>
  );
};

export default HeroSection;
